export default ["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  // Now set up the states
  $stateProvider
    .state('cardDetails', {
      parent: "app",
      url: "/cardDetails/:id",
      feature: "menu.settings.cardDetails",
      views: {
        "main": {
          template: require("./eaCardDetailsPage/eaCardDetailsPageModule.tpl.html"),
          controller: "eaCardDetailsPageModuleController as $ctrl"
        }
      },
      resolve: {
        ctrl: ["$q", "$ocLazyLoad", ($q, $ocLazyLoad)=> {
          return $q((resolve)=> {
            require.ensure([], ()=> {

              let module = require("./index.js");
              $ocLazyLoad.load({name: module.default});
              resolve();
            });
          });
        }]
      }
    })
    .state('addCard', {
      parent: "app",
      url: "/addCard",
      feature: "menu.settings.addCard",
      views: {
        "main": {
          template: require("./eaAddCardPage/eaAddCardPageModule.tpl.html"),
          controller: "eaAddCardPageModuleController as $ctrl"
        }
      },
      resolve: {
        ctrl: ["$q", "$ocLazyLoad", ($q, $ocLazyLoad)=> {
          return $q((resolve)=> {
            require.ensure([], ()=> {

              let module = require("./index.js");
              $ocLazyLoad.load({name: module.default});
              resolve();
            });
          });
        }]
      }
    });
}];


// WEBPACK FOOTER //
// ./src/ui/modules/eaSettings/eaCardDetails/routes.js